import { FC } from 'react';

import styles from './page404.module.scss'

const NotFoundPage: FC = () => {

  return (
    <div className={styles.wrapper}>
      <div className={styles.block}>
        <h1 className={styles.title}>Merch Online</h1>
        <h2 className={styles.subtitle}>У Вас не достаточно прав для просмотра этой страницы. Обратитесь к администратору.</h2>
      </div>
    </div>
  );
};

export default NotFoundPage;
